import { render, staticRenderFns } from "./Uveitis.vue?vue&type=template&id=470d9b06&scoped=true&"
import script from "./Uveitis.vue?vue&type=script&lang=js&"
export * from "./Uveitis.vue?vue&type=script&lang=js&"
import style0 from "./Uveitis.vue?vue&type=style&index=0&id=470d9b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d9b06",
  null
  
)

export default component.exports